<template>
  <ul class="labelLegend" :class="{ open: open }">
    <template v-for="(item, index) in legendList" :key="index">
      <li>
        <el-switch v-model="item.status" @change="switchClick(item, val)">
        </el-switch>
        <span style="margin-left: 8px">{{ item.name }}</span>
      </li>
    </template>
  </ul>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect } from "vue";
import { createContext, useContext } from "@/hooks/core/useContext.js";
export default defineComponent({
  name: "",
  components: {},
  props: {
    open: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      legendList: [
        {
          status: true,
          name: "热力图",
        },
        {
          status: false,
          name: "分布图",
        },
      ],
    });
    const refData = toRefs(data);
    watchEffect(() => {});
    const switchClick = (item, ind) => {
      emit("getSwitchState", item);
    };

    // emit("getSwitchState", data.openlegendList);
    return {
      ...refData,
      switchClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.labelLegend {
  width: 120px;
  height: 100px;
  position: absolute;
  bottom: 180px;
  right: 15px;
  z-index: 1;
  color: #fff;
  padding: 5px 10px 15px;
  transition: all 0.5s;
  @include flex-col-se-s;
  background-color: rgba(77, 99, 133, 1);
  border-radius: 4px;
  .labelLegendItem {
    cursor: pointer;
    display: flex;
    align-items: center;
    .leftSwitch {
      width: 20px;
      height: 10px;
      background: rgb(63, 58, 58);
      border-radius: 10px;
      position: relative;
      margin-right: 15px;
      .switchCir {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background: #fff;
        position: absolute;
        // left: 0;
      }
      .switchright {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background: #fff;
        position: absolute;
        right: 0;
      }
    }
    .switchState {
      background: #62cfdf;
      pointer-events: none;
    }
  }
  &.open {
    right: 425px;
  }
  .legend {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 10px;
    font-size: 14px;
    :deep(.el-switch__core) {
      width: 25px !important;
      height: 10px !important;
    }
    :deep(.el-switch__action) {
      width: 12px !important;
      height: 12px !important;
    }
  }
  :deep(.el-radio) {
    margin-right: 12px !important;
  }
}
</style>
